import { useEffect, useState } from "react";
import { isDemoOn, setDemo } from "@/lib/demoMask";
import { Camera, X } from "lucide-react";

/**
 * Barra fixa no topo que aparece quando o Modo Demo está ativo.
 * Impede que você esqueça o modo ligado e poste algo com dados reais depois.
 */
export default function DemoBanner() {
  const [on, setOn] = useState(isDemoOn());

  useEffect(() => {
    const handler = () => setOn(isDemoOn());
    window.addEventListener("demo-mode-change", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("demo-mode-change", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  if (!on) return null;

  return (
    <div className="print:hidden bg-gradient-to-r from-fuchsia-600 via-purple-600 to-indigo-600 text-white px-4 py-2 text-sm flex items-center justify-between gap-3" data-testid="demo-banner">
      <div className="flex items-center gap-2 min-w-0">
        <Camera size={16} className="flex-shrink-0" />
        <span className="font-semibold truncate">MODO DEMONSTRAÇÃO ATIVO</span>
        <span className="hidden sm:inline text-white/80">— Nomes de empresa, clientes, fornecedores e CNPJs estão mascarados. Ideal pra gravar vídeos e prints sem expor dados reais.</span>
      </div>
      <button
        onClick={() => { setDemo(false); window.location.reload(); }}
        className="flex items-center gap-1 px-2 py-1 rounded-md bg-white/20 hover:bg-white/30 text-xs font-bold transition-colors flex-shrink-0"
        data-testid="demo-banner-disable"
      >
        <X size={12} /> Desligar
      </button>
    </div>
  );
}
